





































import Vue from 'vue'
import moment from 'moment'

import IrisViewer from '../components/viewer/IrisViewer.vue'

export default Vue.extend({
  components: { IrisViewer },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    logo: {
      type: String
    }
  },

  data() {
    return {
      dates: [] as string[],
      images: {} as any,
      loading: true,
      view: {} as any,
      project: {} as any,
      projectViews: [] as any[],
      unsubscribe: {
        view: () => null as any
      }
    }
  },
  methods: {
    getView(id) {
      this.unsubscribe.view()
      this.$db.collection('views').doc(id).get().then(doc => {
        let view = {} as any
        if (doc.exists) {
          view = {_id: doc.id, ...doc.data()}
          this.view = view;          
          const enabledDates = view.enabledDates.sort((a,b) => a > b ? 1 : -1);
          this.dates = enabledDates;
          const latestEnabled = enabledDates[enabledDates.length - 1];
          const date = new Date(latestEnabled);
          this.getImages(latestEnabled);
        }
      })
    },
    getImages(date) {
      const startDate = new Date(date)
      const endDate = new Date(date)
      endDate.setDate(endDate.getDate()+1)
      window.console.log(`Getting images for view: ${this.id}, date: ${date}`)
      window.console.log(`Getting images for view: ${this.id}, between: ${startDate} ${endDate}`)
      this.$db.collection('views').doc(this.id).collection('images')
      .where('dateCaptured', '>=', startDate)
      .where('dateCaptured', '<', endDate).get().then(snapshot => {
        window.console.log(`${snapshot.size} images received`)
        if (snapshot.size) {
          let imageBaseURL = `https://${this.view.bucket}.ix.time-lapse-systems.co.uk/`;
          if(this.view.imageBaseURL) imageBaseURL = this.view.imageBaseURL;
          const images = [] as any[]
          snapshot.forEach(doc => {
            const { dateCaptured, filename, key } = doc.data()
            window.console.log(imageBaseURL);
            images.push({
              _id: doc.id,
              src: new URL(key, imageBaseURL).href,
              meta: { filename: filename || "unknown", date: dateCaptured.toDate() }
            })
          })
          this.$set(this.images, date, images)
          this.loading = false
          this.$emit('ready')
        }
      }).catch(err => {
        window.console.log(err.message, err)
        alert(err.message || "An unknown error occurred, please refresh the page and try again.")
      })
    },

    removeImage(image) {
      this.$db.collection('views').doc(this.id).collection('images').doc(image._id).delete().then(value => {
        window.console.log('Image successfully deleted.')
      }).catch(err => {
        alert(err.message)
      })
    },

    setLatestImage(image) {
      this.$db.collection('views').doc(this.id).update({
        latestImageDate: image.meta.date,
        latestImageURL: image.src
      }).then(value => {
        alert("Latest image successfully updated.")
      }).catch(err => {
        alert(err.message)
      })
    }
  },

  beforeDestroy() {
    this.unsubscribe.view()
  },

  created() {
    this.getView(this.id)
  }
})
